module.exports = __webpack_public_path__ + "img/lang-picker-color.b582f54.png";